import React, { FC, useState } from "react";
import {
  Container,
  DropItem,
  Divider,
  DropGroup,
  DropHint,
  DropTitle,
} from './styles'
import StyledIcon from "../styled-icon";
import { useNavigate } from "react-router-dom";
import type { PermissionAwareActionItem } from '../../permissions';
import { usePermissionActionFilter } from '../../permissions';

type DropItemType = PermissionAwareActionItem & {
  title:string,
  id:string,
  icon:any,
  divider:boolean,
  disabled?:boolean,
  navigate?:string,
  onClick?:(item:any) => void,
  toChangeColor?:boolean,
  /** Section heading rendered above this item. */
  group?:string,
  /** Secondary line under the title. */
  hint?:string,
  /** Destructive item, rendered in the error color. */
  danger?:boolean,
}
type DropType = {
  active?:boolean,
  handleClose?:any,
  options?:any[],
  itemToEdit?:any,
  checkFiled?:any,
  limitedItems?:any[]
  ref?:any,
}
const DropOptions:FC<DropType> = ({options, itemToEdit, limitedItems, handleClose, ref}) => {
  const filterInput = {
    itemAllowedActions: itemToEdit?.allowed_actions,
    extraGuards: {
      invitationAccepted: !itemToEdit?.invitation,
      invitationPending: Boolean(itemToEdit?.invitation),
    },
  }
  const visibleOptions = usePermissionActionFilter(options || [], filterInput)
  const visibleLimitedItems = usePermissionActionFilter(limitedItems || [], filterInput)

  return (
      <Container role="menu">
        {
          itemToEdit?.invitation ? 
          visibleLimitedItems?.map((item:DropItemType) => (
            <DropItemComponent handleClose={handleClose} itemToEdit={itemToEdit} key={item.id} item={item}/>
               
          )) :
          visibleOptions?.map((item:DropItemType) => (
            <DropItemComponent handleClose={handleClose} itemToEdit={itemToEdit} key={item.id} item={item}/>
               
          ))
        }
      </Container>
    
  )
}

export default DropOptions

const DropItemComponent:FC<any> = ({item, itemToEdit, handleClose}) => {
  const [hover, setHover] = useState<boolean>(false)
  const navigate = useNavigate()
  const [activeIcon, setActiveIcon] = useState<boolean>(false)

 

  return (
    <>
      {item.group ? <DropGroup role="presentation">{item.group}</DropGroup> : null}
      <DropItem
        type="button"
        role="menuitem"
        disabled={item?.disabled}
        onClick={() => {
          if(item?.disabled){
            return
          }
          if(item.onClick){
            item.onClick(itemToEdit)
            handleClose?.()
          }
          if(item.navigate){
            navigate(item.navigate)
            handleClose?.()
          }
        }}
        key={item.id}
        onMouseEnter={() => item?.disabled ? undefined : setHover(true)}
        onMouseLeave={() => setHover(false)}
        onMouseDown={() => item?.disabled ? undefined : setActiveIcon(true)}
        onMouseUp={() => setActiveIcon(false)}

      >
        <div style={{display:'flex', alignItems:item.hint ? 'flex-start' : undefined}}>
          <StyledIcon toChangeColor={item?.toChangeColor} active={activeIcon} hover={hover} src={item.icon}/>
          <div style={{display:'flex', flexDirection:'column', gap:1}}>
            <DropTitle $danger={item.danger}>
              {item.title}
            </DropTitle>
            {item.hint ? <DropHint>{item.hint}</DropHint> : null}
          </div>
        </div>
      </DropItem>
      {item.divider ? 
        <Divider/>
      :
        null
      }
    </>
  )
}
